import { querySelectorAll, querySelector } from './querySelectors';
import diamondSelector from './diamondSelector';
import createSvg from './createSvg';
import { productChange } from './productChange';
import { FORM_ROW_CLASS, PRODUCT_PAGE_CLASS, U_DN_CLASS } from '../config/main';

const BODY_INIT_CLASS = 'sl-init';
const WRAPPER_INIT_CLASS = 'w-custom-select';
const CUSTOM_SELECT_CLASS = 'w-custom-select__select';
const LABEL_CLASS = 'w-custom-select__label';
export const LIST_CLASS = 'w-custom-select__list';
const ITEM_CLASS = 'w-custom-select__item';
const ITEM_DISABLED_CLASS = 'w-custom-select__item--disabled';
const ITEM_SELECTED_CLASS = 'w-custom-select__item--selected';
export const OPEN_CLASS = 'w-custom-select--open';
export const OPTION_ATTR = 'data-option-value';
const LABEL_INNER_TEXT_CLASS = 'js-label-text';
const LABEL_TEXT_ATTR = 'data-label-text';
const LABEL_TEXT_CLASS = 'w-custom-select--with-label-text';
export const ICON_ATTR = 'data-icon';
const ICON_TYPE_ATTR = 'data-options-type';
const ICON_CLASS = 'w-custom-select--with-';
const PRICE_CHANGE_ATTR = 'data-price-change';
const PLACEHOLDER_ATTR = 'data-placeholder';
export const DIAMOND_SELECTOR_CLASS = 'js-select-diamond';
export const CHANGE_NAME_EVENT = 'changeName';
export const MANUAL_CHANGE_EVENT = 'manualChange';
export const SELECT_FILLED_EVENT = 'selectFilled';
const ICON_WRAPPER_CLASS = 'w-custom-select__icon-wrapper';
const HIDE_BLOCK_ATTR = 'data-block-for-hide';

export function getWrapper(element) {
  return element.closest(`.${FORM_ROW_CLASS}`);
};

export function getSelect(wrapper) {
  return querySelector('select', wrapper);
};

let getLabelText = function(select) {
  let item = select.options[select.options.selectedIndex];
  let span = document.createElement('span');

  if (isPlaceholder(item)) {
    span.innerHTML = `
      <span class="${LABEL_INNER_TEXT_CLASS}">
        <small class="placeholder">${item.textContent}</small>
      </span>`;
  }
  else if (isWithLabelText(select)) {
    span.innerHTML = `
      <span class="${LABEL_INNER_TEXT_CLASS}">
        <small>${select.getAttribute(LABEL_TEXT_ATTR)}</small> ${item.textContent}
      </span>`;
  }
  else {
    span.innerHTML = item.textContent;
  }

  let iconType = getSelectIconType(select);
  let optionItem = getOptionIcon(item);

  if (iconType && optionItem) {
    span.appendChild(getOptionIconCode(iconType, optionItem, item));
  }

  return span;
};

let getOptionIconCode = function(iconType, optionItem, item) {
  let iconWrapper = document.createElement('span');
  iconWrapper.classList.add(ICON_WRAPPER_CLASS);

  if (iconType === 'icon') {
    iconWrapper.appendChild(createSvg(optionItem));
  }
  else if (iconType === 'color') {
    let colorSpan = document.createElement('span');
    colorSpan.setAttribute('style', `background-color: ${optionItem};`);
    iconWrapper.appendChild(colorSpan);
  }
  else if (iconType === 'image') {
    iconWrapper.classList.add(`${ICON_WRAPPER_CLASS}--image`);
    let image = document.createElement('img');
    image.setAttribute('src', optionItem);
    image.setAttribute('alt', item.textContent);
    iconWrapper.appendChild(image);
  }

  return iconWrapper;
};

let getItemText = function(item) {
  if (isWithPrice(item)) {
    return `${item.textContent} <small></small>`;
  }

  return item.textContent;
};

let isWithLabelText = function(select) {
  return typeof select.getAttribute(LABEL_TEXT_ATTR) === 'string';
};

export function isDiamondSelector(select) {
  return select.classList.contains(DIAMOND_SELECTOR_CLASS);
};

let getSelectIconType = function(select) {
  return typeof select.getAttribute(ICON_TYPE_ATTR) === 'string' ? select.getAttribute(ICON_TYPE_ATTR) : null;
};

let getOptionIcon = function(option) {
  return typeof option.getAttribute(ICON_ATTR) === 'string' ? option.getAttribute(ICON_ATTR) : null;
};

let isWithPrice = function(item) {
  return typeof item.getAttribute(PRICE_CHANGE_ATTR) === 'string';
};

let isPlaceholder = function(item) {
  return typeof item.getAttribute(PLACEHOLDER_ATTR) === 'string';
};

let setDisabledOptions = function(wrapper, select) {
  let items = querySelectorAll(`.${ITEM_CLASS}`, wrapper);
  let disabledItems = querySelectorAll('option[disabled]', select);
  let disabledValues = [];

  disabledItems.forEach((disabledItem) => {
    disabledValues.push(disabledItem.getAttribute('value'));
  });

  items.forEach((item) => {
    if (disabledValues.indexOf(item.getAttribute(OPTION_ATTR)) !== -1) {
      item.classList.add(ITEM_DISABLED_CLASS);
    }
    else {
      item.classList.remove(ITEM_DISABLED_CLASS);
    }
  });
};

let labelClick = function(event) {
  let wrapper = getWrapper(this);
  let select = getSelect(wrapper);
  let customSelect = querySelector(`.${CUSTOM_SELECT_CLASS}`, wrapper);

  if (!querySelector('li', customSelect)) {
    customSelect.appendChild(fillCustomSelect(select));

    // eslint-disable-next-line no-undef
    let customEvent = new CustomEvent(SELECT_FILLED_EVENT);
    select.dispatchEvent(customEvent);
  }

  if (wrapper.classList.contains(OPEN_CLASS)) {
    wrapper.classList.remove(OPEN_CLASS);
  }
  else {
    wrapper.classList.add(OPEN_CLASS);
  }
};

export function openSelect(select) {
  let wrapper = getWrapper(select);
  wrapper.classList.add(OPEN_CLASS);
}

let checkHiddenContent = function(select) {
  if (typeof select.getAttribute(HIDE_BLOCK_ATTR) === 'string') {
    let item = querySelector(`.${select.getAttribute(HIDE_BLOCK_ATTR)}`);

    if (item) {
      item.classList.toggle(U_DN_CLASS, !parseInt(select.options[select.options.selectedIndex].value, 10));
    }
  }
};

export function rebuildSelect(select) {
  let wrapper = getWrapper(select);
  let label = querySelector(`.${LABEL_CLASS}`, wrapper);
  let labelSpan = querySelector('span', label);

  label.appendChild(getLabelText(select));
  label.removeChild(labelSpan);
  setDisabledOptions(wrapper, select);
  checkHiddenContent(select);
};

let itemChangeName = function(event) {
  let wrapper = getWrapper(this);
  let val = this.value;
  let item = querySelector(`.${ITEM_CLASS}[${OPTION_ATTR}="${val}"]`, wrapper);

  item.textContent = this.textContent;

  if (item.classList.contains(ITEM_SELECTED_CLASS)) {
    rebuildSelect(getSelect(getWrapper(this)));
  }
};

export function itemClick(event) {
  let wrapper = getWrapper(this);
  let select = getSelect(wrapper);
  let lastActive = querySelector(`.${ITEM_SELECTED_CLASS}`, wrapper);

  if (!isDiamondSelector(select)) {
    wrapper.classList.remove(OPEN_CLASS);
  }

  select.value = this.getAttribute(OPTION_ATTR);
  rebuildSelect(select);
  this.classList.add(ITEM_SELECTED_CLASS);

  if (lastActive) {
    lastActive.classList.remove(ITEM_SELECTED_CLASS);
  }

  // eslint-disable-next-line no-undef
  let customEvent = new CustomEvent('change');
  select.dispatchEvent(customEvent);

  if (wrapper.closest(`.${PRODUCT_PAGE_CLASS}`)) {
    productChange(select);
  }
};

let manualChange = function(event) {
  let wrapper = getWrapper(this);

  if (wrapper) {
    let select = getSelect(wrapper);

    if (select) {
      rebuildSelect(select);
      // eslint-disable-next-line no-undef
      let customEvent = new CustomEvent('change');
      select.dispatchEvent(customEvent);

      productChange(select);
    }
  }
};

let fillCustomSelect = function(select) {
  if (isDiamondSelector(select)) {
    return diamondSelector.make(select);
  }

  let list = document.createElement('ul');
  list.classList.add(LIST_CLASS);
  let item;
  let iconType = getSelectIconType(select);

  for (let i = 0; i < select.length; i++) {
    let option = select.options[i];

    if (!isPlaceholder(option)) {
      item = document.createElement('li');
      item.classList.add(ITEM_CLASS);
      item.setAttribute(OPTION_ATTR, option.value);
      item.innerHTML = getItemText(option);
      item.addEventListener('click', itemClick);
      option.addEventListener(CHANGE_NAME_EVENT, itemChangeName);

      if (option.disabled) {
        item.classList.add(ITEM_DISABLED_CLASS);
      }

      if (option === select.options[select.options.selectedIndex]) {
        item.classList.add(ITEM_SELECTED_CLASS);
      }

      let optionItem = getOptionIcon(option);

      if (iconType && optionItem) {
        item.appendChild(getOptionIconCode(iconType, optionItem, option));
      }

      list.appendChild(item);
    }
  }

  return list;
};

let createCustomSelect = function(originalSelect) {
  let customSelect = document.createElement('div');
  customSelect.classList.add(CUSTOM_SELECT_CLASS);

  let label = document.createElement('div');
  label.classList.add(LABEL_CLASS);
  label.innerHTML = '';
  label.appendChild(getLabelText(originalSelect));
  label.addEventListener('click', labelClick);
  customSelect.appendChild(label);

  return customSelect;
};

let init = function(select) {
  if (!select.disabled) {
    let wrapper = getWrapper(select);
    wrapper.classList.add(WRAPPER_INIT_CLASS);
    wrapper.appendChild(createCustomSelect(select));

    if (isWithLabelText(select)) {
      wrapper.classList.add(LABEL_TEXT_CLASS);
    }

    let iconType = getSelectIconType(select);

    if (iconType) {
      wrapper.classList.add(`${ICON_CLASS}${iconType}`);
    }

    select.addEventListener(MANUAL_CHANGE_EVENT, manualChange);
    checkHiddenContent(select);
  }
};

let documentClick = function(event) {
  let current = event.target.closest(`.${OPEN_CLASS}`);
  let opens = querySelectorAll(`.${OPEN_CLASS}`);

  if (!current || opens.length > 1) {
    opens.forEach((open) => {
      if (open !== current) {
        open.classList.remove(OPEN_CLASS);
      }
    });
  }
};

export function select(select) {
  init(select);

  if (!document.body.classList.contains(BODY_INIT_CLASS)) {
    document.body.classList.add(BODY_INIT_CLASS);
    document.addEventListener('click', documentClick);
  }
};
